import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex align-items-baseline" }
const _hoisted_2 = { class: "text-muted mr-s2" }
const _hoisted_3 = { class: "p-dropdown-label" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "p-dropdown-trigger" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "p-dropdown-trigger-icon pi pi-chevron-down",
    "aria-hidden": "true"
  })
], -1)
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["for"]
const _hoisted_7 = { class: "input-panel ml-s1 p-input-icon-right" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1)

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import BaseInputNumber from '@/components/form/BaseInputNumber.vue';

enum LIMIT {
  ALL = 0,
  FROM_100 = 1,
  FROM_500 = 2,
  FROM_1000 = 3,
  CUSTOM = 4,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NoFeeLimitFilter',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue", "onChange", "onHide"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:modelValue', value: number): void;
  (e: 'onChange', value: number): void;
  (e: 'onHide'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: number | undefined;
}

const { t } = useI18n();





const updateModel = value => {
  emits('update:modelValue', value);
};

const customLimit = ref('');

const limits: Array<{ id: LIMIT; label: string; value: number }> = [
  { id: LIMIT.ALL, label: 'All', value: 0 },
  { id: LIMIT.FROM_100, label: 'From $100', value: 100 },
  { id: LIMIT.FROM_500, label: 'From $500', value: 500 },
  { id: LIMIT.FROM_1000, label: 'From $1000', value: 1000 },
  { id: LIMIT.CUSTOM, label: 'Custom', value: +customLimit.value },
];

const limitDropdown = ref();
const noFeeLimit = ref(limits[LIMIT.FROM_100]);
updateModel(noFeeLimit.value.value);

const togglePanel = event => {
  limitDropdown.value.toggle(event);
  limitDropdown.value.eventTarget.classList.toggle('p-overlay-open');
};
const onHidePanel = () => {
  if (!noFeeLimit.value.value) noFeeLimit.value = limits[LIMIT.ALL];
  updateModel(noFeeLimit.value.value);
  limitDropdown.value.hide();
  limitDropdown.value.eventTarget.classList.remove('p-overlay-open');
  emits('onHide');
};
const onShowPanel = () => {
  if (props.modelValue === 0 && !customLimit.value) noFeeLimit.value = limits[LIMIT.ALL];
};
const onCustomLimit = () => {
  noFeeLimit.value = limits[LIMIT.CUSTOM];
};
const clearCustomLimit = () => {
  customLimit.value = '';
  limits[LIMIT.CUSTOM].value = +customLimit.value;
};
const onChangeLimit = limit => {
  clearCustomLimit();
  noFeeLimit.value = limit;
  onHidePanel();
};
const isActive = limit => {
  return noFeeLimit.value.value === limit.value && noFeeLimit.value.id !== LIMIT.CUSTOM;
};
const setCustomNoFeeLimit = event => {
  limits[LIMIT.CUSTOM].value = +customLimit.value;
  if (noFeeLimit.value.id === LIMIT.CUSTOM) noFeeLimit.value.value = event ? +event : 0;
};

return (_ctx: any,_cache: any) => {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('singleSide.noFeeLimit.caption')) + ":", 1),
    _createElementVNode("div", {
      class: "p-dropdown dropdown-button-text",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (togglePanel($event)))
    }, [
      _createElementVNode("div", _hoisted_3, "from $" + _toDisplayString(noFeeLimit.value.value), 1),
      _hoisted_4
    ]),
    _createVNode(_component_OverlayPanel, {
      ref_key: "limitDropdown",
      ref: limitDropdown,
      class: "dropdown-list",
      onHide: onHidePanel,
      onShow: onShowPanel
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(limits, (limit) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: limit.id
          }, [
            (limit.label !== 'Custom')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["flex dropdown-li align-items-center", { active: isActive(limit) }]),
                  onClick: ($event: any) => (onChangeLimit(limit))
                }, [
                  _createVNode(_component_RadioButton, {
                    value: limit,
                    modelValue: noFeeLimit.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((noFeeLimit).value = $event)),
                    id: limit.id
                  }, null, 8, ["value", "modelValue", "id"]),
                  _createElementVNode("label", {
                    for: limit.id.toString(),
                    class: "ml-s1"
                  }, _toDisplayString(limit.label), 9, _hoisted_6)
                ], 10, _hoisted_5))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "flex align-items-center pl-s3",
                  onClick: onCustomLimit
                }, [
                  _createVNode(_component_RadioButton, {
                    value: limit,
                    modelValue: noFeeLimit.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((noFeeLimit).value = $event)),
                    id: limit.id
                  }, null, 8, ["value", "modelValue", "id"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(BaseInputNumber, {
                      modelValue: customLimit.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((customLimit).value = $event)),
                      onInput: _cache[4] || (_cache[4] = ($event: any) => (setCustomNoFeeLimit($event))),
                      placeholder: 'Enter custom amount',
                      "input-class": "text-left"
                    }, null, 8, ["modelValue"]),
                    (customLimit.value)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "pi pi-times clickable",
                          onClick: clearCustomLimit
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
          ], 64))
        }), 64)),
        _hoisted_8
      ]),
      _: 1
    }, 512)
  ]))
}
}

})